import React, { useEffect, useState } from "react";
import {
  BarChartSummary,
  BarChartComparison,
  ComparativeTable,
  LineChartComparison
} from "../Charts";
import {
  filterData,
  processFilteredData
} from "../../utils/filterFunctions";
import "./Pages.css";

const EstupefacientesView = ({ filters, frozenKey, dates, handleFilterClick, topN, fetchWithSpinner, data, setData, comparisonYear }) => {

  useEffect(() => {
    fetchWithSpinner({
      startDate: dates.start,
      endDate: dates.end,
      year_to_compare: comparisonYear,
      endpoint: 'operatividad/estupefacientes',
    }, setData);
  }, [dates.start, dates.end, comparisonYear]);

  const currentYear = dates.end ? new Date(dates.end).getFullYear() : new Date().getFullYear();

  const filteredData = filterData(data, filters);

  const dias = [...new Set(data.map(h => h.dia))];
  const jornadas = [...new Set(data.map(h => h.jornada))];

  const results = processFilteredData(filteredData, {
    includeTotals: true,
    groupByFields: ["mes", "barrio", "comuna", "tipo_droga"],
    includeDayShift: true,
    dias,
    jornadas
  }, comparisonYear, currentYear);

  const { totals: { total1, total2, diferencia, variacion }, resumenData } = results;
  const mesData = results.groups.mes;
  const barrioDataRaw = results.groups.barrio.sort((a, b) => (b[currentYear] + b[comparisonYear]) - (a[currentYear] + a[comparisonYear]));
  const barrioData = barrioDataRaw.slice(0, Math.min(topN, barrioDataRaw.length));
  const comunaData = results.groups.comuna.sort((a, b) => (b[currentYear] + b[comparisonYear]) - (a[currentYear] + a[comparisonYear]));
  const tipoDrogaDataRaw = results.groups.tipo_droga.sort((a, b) => (b[currentYear] + b[comparisonYear]) - (a[currentYear] + a[comparisonYear]));
  const tipoDrogaData = tipoDrogaDataRaw.slice(0, Math.min(topN, tipoDrogaDataRaw.length));
  const diasJornadaData1 = results.diasJornadaData[comparisonYear];
  const diasJornadaData2 = results.diasJornadaData[currentYear];

  return (
    <div className="dashboard-grid">
      <div className="row top">
        <div className="card small">
          <BarChartSummary
            resumenData={resumenData}
            diferencia={diferencia}
            variacion={variacion}
            xKey="name"
            title="Resumen general"
            selectedKey={filters.año}
            frozenKey={frozenKey}
            onBarClick={(d) => handleFilterClick("año", d?.category, "Resumen general")}
          />
        </div>
        <div className="card wide">
          <BarChartComparison
            showData={barrioData}
            xKey="name"
            title="Incautación por barrio"
            selectedKey={filters.barrio}
            frozenKey={frozenKey}
            onBarClick={(d) => handleFilterClick("barrio", d?.category, "Incautación por barrio")}
          />
        </div>
      </div>
      <div className="row middle">
        <div className="column-right">
          <div className="row bottom">
            <div className="card medium">
              <BarChartComparison
                showData={tipoDrogaData}
                xKey="name"
                title="Tipo de droga incautada"
                selectedKey={filters.tipo_droga}
                frozenKey={frozenKey}
                onBarClick={(d) => handleFilterClick("tipo_droga", d?.category, "Tipo de droga incautada")}
              />
            </div>
            <div className="card medium">
              <LineChartComparison
                showData={mesData}
                xKey="name"
                title="Incautación de esturpefacientes por mes"
                selectedKey={filters.mes}
                frozenKey={frozenKey}
                onBarClick={(d) => handleFilterClick("mes", d?.category, "Incautación de esturpefacientes por mes")}
              />
            </div>
          </div>
          <div className="row bottom">
            <div className="card medium">
              <BarChartComparison
                showData={comunaData}
                xKey="name"
                title="Incautación de esturpefacientes por comuna"
                selectedKey={filters.comuna}
                frozenKey={frozenKey}
                onBarClick={(d) => handleFilterClick("comuna", d?.category, "Incautación de esturpefacientes por comuna")}
              />
            </div>
            <div className="card medium">
              <ComparativeTable
                previousData={diasJornadaData1}
                previousYear={comparisonYear}
                currentData={diasJornadaData2}
                currentYear={currentYear}
                title="Incautación por día y jornada"
                selectedKey={filters.diaJornada}
                frozenKey={frozenKey}
                onBarClick={(d) => handleFilterClick("diaJornada", d?.category, "Incautación por día y jornada")}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EstupefacientesView;
